// ENT_BTN_TYPE이 있는 GNRL_STD 학습 플레이어 구조 클래스
import PlayerInfo from "./PlayerInfo.class";

class GeneralEntBtnTypeNormalPlayerInfo extends PlayerInfo {
    MMBR_SEQ;
    CLAS_SEQ;
    LEC_SEQ;
    PLAYER_TYPE;
    ENT_BTN_TYPE;

    STD_TY_DVSN_CD = "GNRL_STD";

    constructor(info) {
        super(info.PLAYER_TYPE, { STD_TY_DVSN_CD: "GNRL_STD", ...info });

        this.MMBR_SEQ = info.MMBR_SEQ;
        this.CLAS_SEQ = info.CLAS_SEQ;
        this.LEC_SEQ = info.LEC_SEQ;
        this.PLAYER_TYPE = info.PLAYER_TYPE;
        this.ENT_BTN_TYPE = info.ENT_BTN_TYPE;
    }
}

export default GeneralEntBtnTypeNormalPlayerInfo;
